export const environment = {
  production: false,
  isETopocartDev: false,
  isETopocartProd: false,
  isTopocart: false,
  isTopocartDev: true,
  isPortoVelho: false,
  isAlexania: false,
  isManaus: false,
  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  /* Para ambientes onPremise é necessário a modificação da chave
  do reCAPTCHA, acesse https://www.google.com/recaptcha/admin
  com uma conta do dominio @topocart.com.br e crie uma chave para o dominio
do tipo v2/checkbox  que sera realizado o deploy */
  captchaKey: '6Lea54kpAAAAANda_edNp3kvEmUqrLIvwWHLzdwj',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',
  reportsUrl: 'https://relatorios.desenvolvimento.geo360.topocart.dev.br/',
  reportUrl: 'https://relatorios.desenvolvimento.geo360.topocart.dev.br/',

  visualizador360BaseUrl: 'https://visualizador360.desenvolvimento.geo360.topocart.dev.br',
  apiUrl: 'https://plataforma.desenvolvimento.geo360.topocart.dev.br/',
  conversorUrl: 'https://conversor.desenvolvimento.geo360.topocart.dev.br/',
  apiDjangoUrl:
    'https://plataforma.desenvolvimento.geo360.topocart.dev.br/django/',
  apiUrlPostgrest:
    'https://rest.<placeholder>.desenvolvimento.geo360.topocart.dev.br',
  apiUrlGenericPostgrest:
    'https://rest.plataforma.desenvolvimento.geo360.topocart.dev.br',
  apiUrlGenericPGTiles:
    'https://gateway.desenvolvimento.geo360.topocart.dev.br/plataforma/tiles/',
  apiUrlPGTiles:
    'https://tiles.<placeholder>.desenvolvimento.geo360.topocart.dev.br/',
  apiDjangoDirectUrl:
    'https://cadastro.desenvolvimento.geo360.topocart.dev.br/',
  djangoDirectUrlToken: 'Bearer edd8ceaa-343b-41ef-b5ef-6f03a5122d2b',
  apiAttributesTable:
    'https://tabela-atributos.desenvolvimento.geo360.topocart.dev.br/',
  postgRestUrl:
    'https://rest.<placeholder>.desenvolvimento.geo360.topocart.dev.br',
  pgtilesUrl:
    'https://tiles.<placeholder>.desenvolvimento.geo360.topocart.dev.br',
  caracterizacaoUrl:
    'https://caracterizacao.desenvolvimento.geo360.topocart.dev.br',
  reportV2Url: 'https://relatorios-v2.desenvolvimento.geo360.topocart.dev.br/',

  openRestUrl: 'https://openrest.desenvolvimento.geo360.topocart.dev.br/',


  apiCNAE: 'https://cnae.criciuma.apps.etopocart.com/',

  // apiUrl: 'https://api4.webgeo.io/' /* API Oficial */,
  geoServerUrl: 'https://mapsrv2.webgeo.io/geoserver/',
  // apiUrl: 'https://staging-api.webgeo.io/' /* API Staging */,
  geoServerWFSUrl:
    'https://mapsrv2.webgeo.io/geoserver/wfs' /* GeoServer WFS */,
  photonApi: 'https://photon.komoot.de/api/' /* Photon API */,
  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qjL336AjXfdroCJwNUwQvg',
    authDomain: 'webgeo-test.firebaseapp.com',
    databaseURL: 'https://webgeo-test.firebaseio.com',
    projectId: 'webgeo-test',
    storageBucket: 'webgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:web:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6Lea54kpAAAAANda_edNp3kvEmUqrLIvwWHLzdwj',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
  apiGatewayUrl: 'https://api-gateway.geo360.com.br/',
};
